import React, { useEffect, useState } from "react";
import "../../../../Assets/CSS/bulkorder.css";
import "../../oms.css";
import Up from "../../../../Assets/Images/OMS/up.svg";
import Down from "../../../../Assets/Images/OMS/down.svg";
import Loading from "../../../../Assets/Images/OMS_New/unloading.svg";
import { useFormik } from "formik";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import {
  Box,
  Button,
  Card,
  Modal,
} from "@mui/material";
import moment from "moment";
import toast from "react-hot-toast";
import axios from "axios";
import UploadDocs from "../../common/uploadDocs";
import ShowPDF from "../../common/pdfViewer";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function UnloadingDetailsBuyerForm({ orderId, omsData, getOMSData }) {
  const isPending = omsData?.only_bnps?.ayekart_lvl1_status !== 'Approved' || omsData?.only_bnps?.ayekart_lvl2_status !== 'Approved';
  const [buyerUnloading, setBuyerUnloading] = useState(false);
  const [openDoc, setOpenDoc] = useState(false);
  const handleOpenDoc = () => {
    setOpenDoc(true);
  };
  const handleCloseDoc = () => setOpenDoc(false);
  const [supplierDoc, setSupplierDoc] = useState([]);
  const addObject = (newObject) => {
    setSupplierDoc([...supplierDoc, newObject]);
  };
  const handleAddObject = (newObject) => {
    addObject(newObject);
  };
  const [pdfUrl, setPdfUrl] = useState("");
  const [activeModal, setActiveModal] = useState(false);

  const validate = (values) => {
    const errors = {};
    if (!values.gross_weight) {
      errors.gross_weight = "Gross Weight is Required";
    }
    if (!values.tare_weight) {
      errors.tare_weight = "Tare Weight is Required";
    }

    if (!values.selling_price_to_buyer) {
      errors.selling_price_to_buyer = "Selling Price To Buyer is Required";
    }

    if (!values.total_price_for_commodity) {
      errors.total_price_for_commodity = "Total Commodity Price is Required";
    }

    if (!values.packaging_bag_type) {
      errors.packaging_bag_type = "Packaging Bag Type is Required";
    }
    if (!values.no_of_gunny_bags) {
      errors.no_of_gunny_bags = "Number of Gunny bags is Required";
    }

    if (!values.unloading__staff_actioner) {
      errors.unloading__staff_actioner = "Unloading staff name is Required";
    }

    return errors;
  };

  const initialValues = {
    gross_weight: null,
    tare_weight: null,
    selling_price_to_buyer: null,
    total_price_for_commodity: null,
    packaging_bag_type: null,
    no_of_gunny_bags: null,
    net_weight: 0,
    buyer_unloading: null,
    buyer_unloading_time: null,
    buyer_unloading_actioner: null,
    unloading__staff_actioner: null,
    unloading_weight_short: null,
    unloading_weight_gain: null,
    unloading_number_accepted_bags: null,
    unloading_number_rejected_bags: null,
    unloading_attachments: null,
  };

  const bagOptions = [
    { label: "Jute", value: "jute" },
    { label: "Nylon", value: "nylon" },
    { label: "Bopp", value: "bopp" },
    { label: "Poly Bag", value: "polybag" },
  ];

  const calculateNetWeight = () => {
    const grossWeight = formik.values.gross_weight || 0;
    const tareWeight = formik.values.tare_weight || 0;
    const netWeight = grossWeight - tareWeight;
    formik.setFieldValue("net_weight", netWeight);
  };

  const handleSubmit = async (values) => {
    console.log(values);
    const actioner = JSON.parse(localStorage.getItem("user_detail"));

    const payload = {
      order_id: orderId,
      buyer_unloading: true,
      buyer_unloading_time: moment(new Date()).format(),
      buyer_unloading_actioner: actioner?.user_name
        ? actioner?.user_name
        : null,
      buyer_gross_weight: values.gross_weight ? values.gross_weight : null,
      buyer_tare_weight: values.tare_weight ? values.tare_weight : null,
      buyer_packaging_bag_type: values.packaging_bag_type
        ? values.packaging_bag_type
        : null,
      buyer_no_of_gunny_bags: values.no_of_gunny_bags
        ? values.no_of_gunny_bags
        : null,
      unloading__staff_actioner: values?.unloading__staff_actioner
        ? values?.unloading__staff_actioner
        : null,
      unloading_number_accepted_bags: values?.unloading_number_accepted_bags
        ? values?.unloading_number_accepted_bags
        : 0,
      unloading_weight_short: values?.unloading_weight_short
        ? values?.unloading_weight_shor
        : 0,
      unloading_weight_gain: values?.unloading_weight_gain
        ? values?.unloading_weight_gain
        : 0,
      unloading_number_rejected_bags: values?.unloading_number_rejected_bags
        ? values?.unloading_number_rejected_bags
        : 0,
      buyer_total_commodity_price: values.total_price_for_commodity
        ? values.total_price_for_commodity
        : null,
      selling_price_to_buyer: values.selling_price_to_buyer
        ? values.selling_price_to_buyer
        : null,
      buyer_net_weight: values.net_weight ? values?.net_weight : null,
      unloading_attachments: omsData?.unloading_attachments
        ? [...omsData?.unloading_attachments, ...supplierDoc]
        : [...supplierDoc],
    };

    try {
      const { data } = await axios.patch("/api/orders/update", payload);
      if (data.status) {
        formik.resetForm();
        getOMSData();
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error);
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    validate,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    calculateNetWeight();
  }, [formik.values.gross_weight, formik.values.tare_weight]);

  useEffect(() => {
    formik.setValues({
      ...formik.values,
      gross_weight: omsData?.buyer_gross_weight
        ? omsData?.buyer_gross_weight
        : null,
      tare_weight: omsData?.buyer_tare_weight
        ? omsData?.buyer_tare_weight
        : null,
      selling_price_to_buyer: omsData?.selling_price_to_buyer
        ? omsData?.selling_price_to_buyer
        : null,
      total_price_for_commodity: omsData?.buyer_total_commodity_price
        ? omsData?.buyer_total_commodity_price
        : null,
      packaging_bag_type: omsData?.buyer_packaging_bag_type
        ? omsData?.buyer_packaging_bag_type
        : null,
      no_of_gunny_bags: omsData?.buyer_no_of_gunny_bags
        ? omsData?.buyer_no_of_gunny_bags
        : null,
      net_weight: omsData?.buyer_net_weight || 0,
      unloading__staff_actioner: omsData?.unloading__staff_actioner
        ? omsData?.unloading__staff_actioner
        : null,
      unloading_weight_short: omsData?.unloading_weight_shor
        ? omsData?.unloading_weight_shor
        : 0,
      unloading_weight_gain: omsData?.unloading_weight_gain
        ? omsData?.unloading_weight_gain
        : 0,
      unloading_number_accepted_bags: omsData?.unloading_number_accepted_bags
        ? omsData?.unloading_number_accepted_bags
        : 0,
      unloading_number_rejected_bags: omsData?.unloading_number_rejected_bags
        ? omsData?.unloading_number_rejected_bags
        : 0,
    });
  }, [omsData, formik.setValues]);
  // --------------------------------- view Doc In card -------------------------------------

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function changePage(offset) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  // ------------------------------------ View pdf files -----------------------------------------------
  const handleModalClose = () => {
    setPdfUrl("");
    setActiveModal(false);
  };

  const handleModalOpen = (pdfUrl) => {
    setPdfUrl(pdfUrl);
    setActiveModal(true);
  };
  return (
    <div className="shadow-lg m-2 p-2 pb-2 rounded-lg">
      <div className="flex flex-col sm:flex-row justify-between">
        <div className="font-medium text-cyan-950 text-md flex gap-2">
          <img src={Loading} alt="" />
          <div> Unloading Details</div>
          {
            !omsData.supplier_loading && (
              <span style={{color: 'red'}}>(Supplier loading not added)</span>
            )
          }
        </div>
        <div>
          {buyerUnloading ? (
            <div className="font-medium text-cyan-950 text-lg mt-2">
              <img
                src={Up}
                alt=""
                role="button"
                onClick={() => setBuyerUnloading(!buyerUnloading)}
              />
            </div>
          ) : (
            <div className="font-medium text-cyan-950 text-lg mt-2">
              <img
                src={Down}
                alt=""
                role="button"
                onClick={() => setBuyerUnloading(!buyerUnloading)}
              />
            </div>
          )}
        </div>
      </div>
      <div>
        <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
      </div>
      <div>
        {buyerUnloading ? (
          <></>
        ) : (
          <div>
            <form onSubmit={formik.handleSubmit}>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                <div>
                  <label
                    for="gross_weight"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Gross Weight(Kg)
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    min={0}
                    id="gross_weight"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="gross_weight"
                    onChange={(e) => {
                      formik.handleChange(e);
                    }}
                    value={formik.values.gross_weight}
                    placeholder="Enter Gross Weight"
                    disabled={isPending || !omsData.supplier_loading}
                  />
                  {formik.errors.gross_weight && formik.touched.gross_weight ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.gross_weight}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="tare_weight"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Tare weight(Kg)
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    min={0}
                    id="tare_weight"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="tare_weight"
                    onChange={(e) => {
                      formik.handleChange(e);
                    }}
                    value={formik.values.tare_weight}
                    placeholder="Enter Tare Weight"
                    disabled={isPending || !omsData.supplier_loading}
                  />
                  {formik.errors.tare_weight && formik.touched.tare_weight ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.tare_weight}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="net_weight"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Net Weight(Kg)
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    min={0}
                    id="net_weight"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="net_weight"
                    disabled
                    onChange={(e) => {
                      formik.handleChange(e);
                    }}
                    value={formik.values.net_weight}
                  />
                  {formik.errors.net_weight && formik.touched.net_weight ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.net_weight}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="selling_price_to_buyer"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Selling Price To Buyer
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    min={0}
                    id="selling_price_to_buyer"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="selling_price_to_buyer"
                    placeholder="Enter Selling Price To Buyer (Rs)"
                    onChange={(e) => {
                      formik.handleChange(e);
                    }}
                    value={formik.values.selling_price_to_buyer}
                    disabled={isPending || !omsData.supplier_loading}
                  />
                  {formik.errors.selling_price_to_buyer && formik.touched.selling_price_to_buyer ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.selling_price_to_buyer}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="total_price_for_commodity"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Total Price For Commodity
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    min={0}
                    id="total_price_for_commodity"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="total_price_for_commodity"
                    placeholder="Enter Commodity Price (Rs)"
                    onChange={(e) => {
                      formik.handleChange(e);
                    }}
                    value={formik.values.total_price_for_commodity}
                    disabled={isPending || !omsData.supplier_loading}
                  />
                  {formik.errors.total_price_for_commodity && formik.touched.total_price_for_commodity ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.total_price_for_commodity}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                    Packaging Bag Type
                  </label>
                  <select
                    value={formik.values.packaging_bag_type}
                    onChange={formik.handleChange}
                    name="packaging_bag_type"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    disabled={isPending || !omsData.supplier_loading}
                  >
                    <option value="Select Expense">Select Option</option>
                    {bagOptions.map((each, index) => (
                      <option value={each.value} key={index}>
                        {each.label}
                      </option>
                    ))}
                  </select>
                  {formik.errors.packaging_bag_type && formik.touched.packaging_bag_type ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.packaging_bag_type}
                    </div>
                  ) : null}
                </div>

                <div>
                  <label
                    for="no_of_gunny_bags"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Number of Gunny Bags / Crates / Boxes
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    min={0}
                    id="no_of_gunny_bags"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="no_of_gunny_bags"
                    placeholder="Enter Number of Bags"
                    value={formik.values.no_of_gunny_bags}
                    onChange={formik.handleChange}
                    step="any"
                    disabled={isPending || !omsData.supplier_loading}
                  />
                  {formik.errors.no_of_gunny_bags && formik.touched.no_of_gunny_bags ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.no_of_gunny_bags}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="no_of_gunny_bags"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Unloading Staff Name
                  </label>
                  <input
                    type="text"
                    id="unloading__staff_actioner"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="unloading__staff_actioner"
                    placeholder="Enter Unloading Staff Name"
                    value={formik.values.unloading__staff_actioner}
                    onChange={formik.handleChange}
                    step="any"
                    disabled={isPending || !omsData.supplier_loading}
                  />
                  {formik.errors.unloading__staff_actioner && formik.touched.unloading__staff_actioner ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.unloading__staff_actioner}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="unloading_date"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Unloading Date
                  </label>
                  <input
                    type="Date"
                    id="unloading_date"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="unloading_date"
                    placeholder="Enter Unloading Date"
                    value={formik.values.unloading_date}
                    onChange={formik.handleChange}
                    step="any"
                    disabled={isPending || !omsData.supplier_loading}
                  />
                  {formik.errors.unloading__staff_actioner && formik.touched.unloading__staff_actioner ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.unloading_date}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="unloading_weight_short"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Weight Short
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    min={0}
                    id="unloading_weight_short"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="unloading_weight_short"
                    placeholder="Enter weight short"
                    value={formik.values.unloading_weight_short}
                    onChange={formik.handleChange}
                    step="any"
                    disabled={isPending || !omsData.supplier_loading}
                  />
                  {formik.errors.unloading_weight_short && formik.touched.unloading_weight_short ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.unloading_weight_short}
                    </div>
                  ) : null}
                </div>

                <div>
                  <label
                    for="unloading_weight_gain"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Weight Gain
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    min={0}
                    id="unloading_weight_gain"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="unloading_weight_gain"
                    placeholder="Enter weight Gain"
                    value={formik.values.unloading_weight_gain}
                    onChange={formik.handleChange}
                    step="any"
                    disabled={isPending || !omsData.supplier_loading}
                  />
                  {formik.errors.unloading_weight_gain && formik.touched.unloading_weight_gain ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.unloading_weight_gain}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="unloading_number_accepted_bags"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Number of Accepted Bags
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    min={0}
                    id="unloading_number_accepted_bags"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="unloading_number_accepted_bags"
                    placeholder="Enter Number of Accepted Bags"
                    value={formik.values.unloading_number_accepted_bags}
                    onChange={formik.handleChange}
                    step="any"
                    disabled={isPending || !omsData.supplier_loading}
                  />
                  {formik.errors.unloading_number_accepted_bags && formik.touched.unloading_number_accepted_bags ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.unloading_number_accepted_bags}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="unloading_number_rejected_bags"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Number of Rejected Bags
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    min={0}
                    id="unloading_number_rejected_bags"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="unloading_number_rejected_bags"
                    placeholder="Enter Number of Rejected Bags"
                    value={formik.values.unloading_number_rejected_bags}
                    onChange={formik.handleChange}
                    step="any"
                    disabled={isPending || !omsData.supplier_loading}
                  />
                  {formik.errors.unloading_number_rejected_bags && formik.touched.unloading_number_rejected_bags ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.unloading_number_rejected_bags}
                    </div>
                  ) : null}
                </div>
              </div>
              {omsData?.unloading_attachments?.length > 0 ? (
                <div className="flex justify-start mt-2">
                  {" "}
                  <h4 className="text-blue-900">Uploaded Documents</h4>
                </div>
              ) : (
                ""
              )}
              <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-2 gap-4">
                {omsData?.unloading_attachments?.length > 0 &&
                  omsData?.unloading_attachments?.map((item, index) => {
                    return (
                      <>
                        <Card
                          sx={{
                            width: ["100%", "100%", "100%", "100%"],
                            bgcolor: "background.paper",
                            boxShadow: 24,
                            borderRadius: 4,
                            maxHeight: 300,
                            overflow: "auto",
                            backgroundColor: "#FEFEFE",
                          }}
                        >
                          <div className="flex justify-between m-2 mb-2">
                            <h5 className="text-center mt-2">
                              {" "}
                              {item?.type} Document
                            </h5>
                            <div className="flex justify-center">
                              <h5 className="flex justify-between  text-teal-700 mt-2 ">
                                <Button
                                // onClick={() =>
                                //   downloadPDF(
                                //     item?.url,
                                //     `${new Date().toLocaleDateString()}_${
                                //       item?.type
                                //     }`
                                //   )
                                // }
                                >
                                  <FileDownloadIcon
                                    icon="subway:download-1"
                                    width="24"
                                    height="24"
                                    className="ms-3"
                                    role="button"
                                  />
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={item?.url}
                                  >
                                    Download
                                  </a>
                                </Button>
                              </h5>
                              <Button
                                onClick={() => handleModalOpen(item?.url)}
                              >
                                {" "}
                                View
                              </Button>
                            </div>
                          </div>

                          <div className=" flex justify-center border-2 mt-4 pb-5 border-b-teal-900  p-3">
                            {item?.url?.includes(".pdf") ? (
                              <Document
                                maxHeight={200}
                                maxWidth={300}
                                file={item?.url}
                                onLoadSuccess={onDocumentLoadSuccess}
                                onLoadError={(error) =>
                                  console.error(
                                    "Error while loading document!",
                                    error
                                  )
                                }
                              >
                                <Page pageNumber={pageNumber} />
                              </Document>
                            ) : (
                              <img src={item?.url} alt="" />
                            )}
                          </div>
                          <div className="flex justify-between mt-5 pb-3">
                            <p className="">
                              Page {pageNumber || (numPages ? 1 : "--")} of{" "}
                              {numPages || "--"}
                            </p>
                            <div className="flex gap-2">
                              <Button
                                size="small"
                                variant="contained"
                                disabled={pageNumber <= 1}
                                onClick={previousPage}
                                sx={{ backgroundColor: "#040D43" }}
                              >
                                Previous
                              </Button>
                              <Button
                                size="small"
                                className="ml-2"
                                variant="contained"
                                disabled={pageNumber >= numPages}
                                onClick={nextPage}
                                sx={{ backgroundColor: "#040D43" }}
                              >
                                Next
                              </Button>
                            </div>
                          </div>
                        </Card>
                      </>
                    );
                  })}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-3 mt-2 ">
                <div>
                  <label
                    for="branch"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                  >
                    Add Documents
                  </label>
                  <Button
                    sx={{ backgroundColor: "gray" }}
                    variant="contained"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    onClick={() => handleOpenDoc()}
                    disabled={isPending || !omsData.supplier_loading}
                  >
                    <CloudUploadIcon />
                    <b className="ms-2 mt-1">Upload Documents</b>
                  </Button>
                </div>
              </div>
              <div className="flex justify-end mt-2">
                {/*<Button 
                      color="error"
                      onClick={(e) => formik.resetForm()}
                    >
                      CLEAR
                    </Button>
                    */}
                <Button
                  variant="contained"
                  size="small"
                  type="submit"
                  sx={{ backgroundColor: "#0D9223" }}
                  disabled={isPending || !omsData.supplier_loading}
                >
                  SAVE
                </Button>
              </div>
            </form>
          </div>
        )}
      </div>
      <UploadDocs
        open={openDoc}
        handleClose={handleCloseDoc}
        handleAddObject={handleAddObject}
      />

      <Modal
        open={activeModal}
        onClose={handleModalClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            width: "50%",
            height: "80%",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            overflowY: "auto",
          }}
        >
          <div className="">
            <IconButton
              aria-label="close"
              style={{ position: "absolute", right: "8px", top: "8px" }}
              onClick={() => handleModalClose()}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="flex flex-col items-center justify-center space-y-5 h-full">
            {pdfUrl?.toLowerCase().endsWith(".pdf") ? (
              <ShowPDF pdfUrl={pdfUrl} />
            ) : (
              <img src={pdfUrl} alt="uploaded image" />
            )}
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default UnloadingDetailsBuyerForm;
